export const handleFilename = (file) => {
  if (file) {
    const filename = file?.split("/");
    const extension = filename[filename?.length - 1];
    return extension;
  } else {
    return null;
  }
};
